<template>
  <section>
    <page-header
      :title="name"
      :subtitle="`${wine.name}${wine.vintage ? ' ' + wine.vintage : ''} ${wine.winegrower}, ${wine.region}`"
      class="my-20"
    />
    <div class="w-full flex flex-col md:flex-row mt-5 mb-6 px-12">
      <div class="w-full md:w-2/6 flex flex-auto items-center my-5">
        <img class="ml-auto mr-auto block h-full" :src="campaign.media.imgSrc" alt="" />
      </div>

      <div class="w-full md:w-3/6 flex flex-col my-5 md:px-5">
        <p v-for="(block, key) in campaign.description" :key="key" class="text-base md:text-xl">
          {{ block ? block : '&nbsp;' }}
        </p>
        <ul v-if="campaign.links && campaign.links.length > 0" class="my-4 text-base text-lg">
          <li v-for="(item, index) of campaign.links" :key="index">
            <nuxt-link class="no-underline hover:underline text-gray-800 hover:text-orange-500" :to="item.uri">{{
              item.name
            }}</nuxt-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="mt-8 mb-6">
      <div v-if="campaign.discount && isCurrent" class="text-center">
        <span class="text-base text-2xl mr-3">{{ wine.size }}</span>
        <span class="text-base text-2xl mr-3 line-through">{{ campaign.price }}* {{ campaign.currency }}</span>
        <span class="text-base text-2xl underline">{{ campaign.discount }}* {{ campaign.currency }}</span>
      </div>
      <div v-else class="text-center">
        <span class="text-base text-2xl ml-3">{{ wine.size }}</span>
        <span class="text-base text-2xl">{{ campaign.price }}* {{ campaign.currency }}</span>
      </div>
      <div class="text-center mt-5 mb-8">
        <p class="text-base text-xs">* Alle Preise inkl. 19% MwSt, enthält Sulfite</p>
      </div>
      <div>
        <p class="text-base text-xl text-center">(Beim Kauf von 12 Flaschen, erhalten Sie eine weitere als Rabatt!)</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@/components/layout/PageHeader'

export default {
  components: {
    PageHeader,
  },
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    showDiscount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      now: Date.now(),
    }
  },
  computed: {
    ...mapGetters({
      getCampaign: 'campaign/getCampaignById',
    }),
    campaign() {
      return this.getCampaign(this.campaignId)
    },
    wine() {
      return this.campaign.wine
    },
    isCurrent() {
      if (this.showDiscount) return true
      return (
        this.year(this.campaign.beginCampaign) === this.currentYear &&
        this.month(this.campaign.beginCampaign) === this.currentMonth
      )
    },
    currentYear() {
      return new Date().getFullYear()
    },
    currentMonth() {
      return new Date().toLocaleString('de-de', { month: 'long' })
    },
  },
  methods: {
    year(start) {
      return new Date(Date.parse(start)).getFullYear()
    },
    month(start) {
      const date = new Date(Date.parse(start))
      return date.toLocaleString('de-de', { month: 'long' })
    },
  },
}
</script>
